import TableMatchText from './TableMatchText'
import { Document } from '@/assets/icons'
import TableReferenceLink from './TableReferenceLink'

export default function TableFileCell({ matterId, document }: { matterId: string; document: { id: string | null; name: string } }) {
  if (!document.id) return <span className="text-xs text-brand-neutral-600">Unavailable file</span>
  return (
    <TableReferenceLink
      matterId={matterId}
      reference={{ document_id: document.id, document_name: document.name }}
      className="text-xs rounded flex items-center px-2 py-1 gap-1.5 min-h-[26px] bg-brand-neutral-50 ring-1 ring-inset ring-brand-neutral-200 hover:bg-brand-neutral-100 transition-colors w-fit max-w-full"
    >
      <Document className="w-[18px] h-[18px] text-brand-neutral-800 shrink-0" aria-hidden />
      <span className="truncate font-medium text-brand-neutral-800" title={document.name}>
        <TableMatchText text={document.name} />
      </span>
    </TableReferenceLink>
  )
}
